import LovLocal from '@/components/Lov/LovLocal'

export default {
  install: function (Vue) {
    Vue.component('LovLocal', LovLocal)
  },
}
